import { CalendarDateRange, SelectedRange } from '@app/shared/models/volume-dashboard.model';
import { parseCalendarDate, localizeCalendarDate } from './calendar-date';

export function comparisonRangeLabel(period: CalendarDateRange | null, lang: string): string {
  if (!period) return '';
  const md: Intl.DateTimeFormatOptions = { month: 'short', day: 'numeric' };
  const mdy: Intl.DateTimeFormatOptions = { month: 'short', day: 'numeric', year: 'numeric' };
  const startOptions = period.from.slice(0, 4) === period.to.slice(0, 4) ? md : mdy;
  const start = localizeCalendarDate(period.from, startOptions, lang);
  return `${start} – ${localizeCalendarDate(period.to, mdy, lang)}`;
}

export function selectedRangeReachesBeforeData(
  range: SelectedRange | null,
  dataSince: string | null | undefined
): boolean {
  if (!range || !dataSince) return false;
  return range.from < parseCalendarDate(dataSince);
}

export function comparisonReachesBeforeData(
  period: CalendarDateRange | null,
  dataSince: string | null | undefined
): boolean {
  if (!period || !dataSince) return false;
  return parseCalendarDate(period.from) < parseCalendarDate(dataSince);
}

export function formatDataSince(dataSince: string | null | undefined, lang: string): string {
  return dataSince
    ? localizeCalendarDate(dataSince, { month: 'short', day: 'numeric', year: 'numeric' }, lang)
    : '';
}
